<template>
  <div>
    <b-alert variant="danger"
             class="p-5"
             dismissible
             :show="error.isVisible"
             @dismissed="error.isVisible=false">
      <i18n path="error.resetPasswordConfirm.submit">
        <b-link href="mailto:support@meine-vertraege.net" place="supportLink">support@meine-vertraege.net</b-link>
      </i18n>
    </b-alert>
    <b-card class="rounded-0">
      <h4>{{ $t('message.resetPasswordConfirm.title') }}</h4>
      <p>{{ $t('message.resetPasswordConfirm.message') }}</p>
      <b-form @submit.prevent="submit">
        <b-form-row class="mt-3">
          <b-col>
            <b-form-group :state="$v.confirmData.password.$error ? false : null"
                          :invalid-feedback="$t('error.resetPasswordConfirm.password')">
              <label>
                {{ $t('message.resetPasswordConfirm.label.password') }}
                <span class="text-danger">*</span>
              </label>
              <b-form-input v-model="confirmData.password"
                            type="password"
                            :placeholder="$t('message.resetPasswordConfirm.input.placeholder.password')"
                            :state="$v.confirmData.password.$error ? false : null"
                            @change="$v.confirmData.password.$touch()">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="mt-2">
          <b-col>
            <b-form-group :state="$v.confirmData.passwordConfirm.$error ? false : null"
                          :invalid-feedback="$t('error.resetPasswordConfirm.passwordConfirm')">
              <label>
                {{ $t('message.resetPasswordConfirm.label.passwordConfirm') }}
                <span class="text-danger">*</span>
              </label>
              <b-form-input v-model="confirmData.passwordConfirm"
                            type="password"
                            :placeholder="$t('message.resetPasswordConfirm.input.placeholder.passwordConfirm')"
                            :state="$v.confirmData.passwordConfirm.$error ? false : null"
                            @change="$v.confirmData.passwordConfirm.$touch()">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="mt-5">
          <b-col>
            <b-form-group :state="$v.confirmData.verificationCode.$error ? false : null"
                          :invalid-feedback="$t('error.resetPasswordConfirm.verificationCode')">
              <label>
                {{ $t('message.resetPasswordConfirm.label.verificationCode') }}
                <span class="text-danger">*</span>
              </label>
              <b-form-input v-model="confirmData.verificationCode"
                            :placeholder="$t('message.resetPasswordConfirm.input.placeholder.verificationCode')"
                            :state="$v.confirmData.verificationCode.$error ? false : null"
                            @change="$v.confirmData.verificationCode.$touch()">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="mt-5">
          <b-col>
            <b-btn variant="link" @click="back">{{ $t('message.resetPasswordConfirm.btn.back') }}</b-btn>
          </b-col>
          <b-col class="text-right">
            <b-btn variant="primary" type="submit">{{ $t('message.resetPasswordConfirm.btn.send') }}</b-btn>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
  import { required, sameAs } from 'vuelidate/lib/validators'
  import utils from '@/utils'
  export default {
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.fromPath = from.path
        if (to.query.email) {
          vm.confirmData.email = to.query.email
        } else {
          next('/')
        }
      })
    },
    data () {
      return {
        confirmData: {
          email: null,
          password: null,
          passwordConfirm: null,
          verificationCode: null
        },
        error: {
          isVisible: false
        },
        fromPath: '/'
      }
    },
    methods: {
      back () {
        this.$router.replace(this.fromPath)
      },
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.$store.dispatch('confirmResetPassword', this.confirmData)
            .then(() => this.$router.push('/signin'))
            .catch(() => {
              this.error.isVisible = true
            })
        }
      }
    },
    validations: {
      confirmData: {
        password: {
          required,
          isValidPassword: utils.validators.isValidPassword
        },
        passwordConfirm: {
          required,
          sameAsPassword: sameAs('password')
        },
        verificationCode: {
          required
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/ResetPasswordConfirm.vue